import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  Xtp,
  XtpOptions,
  API_PATH_XTPS,
  API_PATH_XTP_OPTIONS,
} from './xtp.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getXtps(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<Xtp>> {
  return http.get(`${API_PATH_XTPS}/${deliveryFunctionId}`);
}

export function getXtp(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<Xtp>> {
  return http.get(`${API_PATH_XTPS}/${deliveryFunctionId}/${id}`);
}

export function createXtp(
  deliveryFunctionId: string,
  body: WithAuditDetails<Xtp>,
): AxiosPromise<ServerResponse<Xtp>> {
  return http.post(`${API_PATH_XTPS}/${deliveryFunctionId}`, body);
}

export function updateXtp(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<Xtp>,
): AxiosPromise<ServerResponse<Xtp>> {
  return http.put(`${API_PATH_XTPS}/${deliveryFunctionId}/${id}`, body);
}

export function deleteXtp(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<Xtp>> {
  return http.delete(`${API_PATH_XTPS}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}

export function getXtpOptions(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<XtpOptions>> {
  return http.get(`${API_PATH_XTP_OPTIONS}/${deliveryFunctionId}`);
}

export function updateXtpOptions(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<XtpOptions>,
): AxiosPromise<ServerResponse<Xtp>> {
  return http.put(`${API_PATH_XTP_OPTIONS}/${deliveryFunctionId}/${id}`, body);
}

export function deleteXtpOptions(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<XtpOptions>,
): AxiosPromise<ServerResponse<Xtp>> {
  return http.delete(`${API_PATH_XTP_OPTIONS}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
